// CodeUnique.jsx
import React from 'react';
import useGetData from "../../../../repo/get"; // Supondo que essa seja sua função para GET

const CodeUnique = ({ id, refreshFlag }) => {
  // Incluímos refreshFlag para que a requisição seja refeita sempre que a flag mudar.
  const { data, loading, error } = useGetData(`api/unique/code/${id}`, { refresh: refreshFlag });

  if (loading) return <span>Carregando...</span>;
  if (error) return <span>Sem código</span>;

  // Se sua API retorna o código em data.code, ajuste se necessário.
  const code = data?.code || "Código não disponível";
  return <span>{code}</span>;
};

export default CodeUnique;
